module.exports = __webpack_public_path__ + "static/media/blue_mark_icon.fcbabac1.svg";